import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  pt: {
    translation: {
      profile: {
        loading: "Carregando perfil...",
        title: "Meu Perfil",
        name: "Nome",
        email: "E-mail",
        logout: "Sair"
      },
      home: {
        loading: "Carregando...",
        activateTitle: "Ative sua assinatura",
        activateMsg: "Para usar o Wappfy, ative sua assinatura. Você terá <b>2 dias grátis</b> para testar.",
        activateBtn: "Ativar agora",
        regularizeTitle: "Regularize sua assinatura",
        regularizeMsg: "Sua assinatura está inativa. Regularize o pagamento para continuar usando.",
        regularizeBtn: "Regularizar",
        signout: "Sair"
      },
      header: {
        documentation: "Documentação",
        documentationSubtitle: "Documentação",
        languageCurrent: "Idioma atual: {{lang}}",
        selectLanguage: "Selecione o idioma",
        portuguese: "Português",
        english: "English",
        "Português": "Português",
        "English": "English",
        userMenu: "Menu do usuário",
        myProfile: "Meu Perfil",
        userId: "ID do usuário",
        copyUserId: "Copiar ID",
        copied: "Copiado!",
        resetPassword: "Redefinir senha",
        resetPasswordSubtitle: "Altere sua senha de acesso",
        partner: "Wappfy Partner",
        partnerSubtitle: "Ganhe comissão indicando amigos",
        support: "Suporte",
        needHelp: "Precisa de ajuda?",
        manageSubscription: "Gerenciar assinatura",
        billing: "Cobrança",
        opening: "Abrindo...",
        logout: "Sair",
        endSession: "Encerrar sessão",
        confirmLogout: "Deseja sair?",
        confirmLogoutMsg: "Tem certeza que deseja sair da sua conta?",
        cancel: "Cancelar",
        confirm: "Confirmar",
        loggingOut: "Saindo...",
        subscription: "Assinatura",
        instances: "instâncias",
        loading: "Carregando...",
        enterprise: "Enterprise",
        enterpriseAdmin: "Gerenciar Enterprise",
        enterpriseUser: "Acessar Enterprise",
        user: "Usuário"
      },
      connectionTable: {
        loading: "Carregando conexões...",
        error: "Erro ao carregar conexões",
        tryAgain: "Tentar novamente",
        filter: "Filtrar",
        sort: "Ordenar",
        sortActive: "Ordenação ativa",
        refresh: "Atualizar",
        newConnection: "Nova Conexão",
        noInstance: "Nenhuma instância encontrada",
        createFirst: "Crie sua primeira instância para começar.",
        noConnections: "Nenhuma conexão encontrada",
        noFilter: "Nenhuma conexão encontrada com este filtro.",
        tryAdjust: "Tente ajustar os filtros.",
        searchPlaceholder: "Pesquisar instâncias...",
        clearSearch: "Limpar pesquisa",
        name: "Nome",
        phone: "Telefone",
        apiKey: "API Key",
        instanceName: "Session/InstanceName",
        host: "Host",
        statusTitle: "Status",
        actions: "Ações",
        actionsConfig: {
          connect: "Conectar QR Code",
          config: "Configurar"
        },
        connect: "Conectar QR Code",
        status: {
          online: "Online",
          connecting: "Conectando",
          disconnected: "Desconectado",
          error: "Erro",
          unknown: "Desconhecido",
          waitingConnection: "Aguardando conexão",
          connected: "Conectada"
        },
        pagination: {
          showing: "Mostrando {{start}}-{{end}} de {{total}} conexões",
          perPage: "por página",
          previous: "Anterior",
          next: "Próximo",
          noConnectionsOnPage: "Nenhuma conexão na página atual"
        }
      },
      novaConexao: {
        nameTitle: "Nome da nova conexão",
        namePlaceholder: "Digite um nome para a conexão",
        creating: "Criando...",
        generate: "Gerar QR Code",
        alertName: "Digite um nome para a conexão."
      },
      filterModal: {
        title: "Filtrar conexões",
        onlineDesc: "Mostrar apenas conexões online",
        connectingDesc: "Mostrar conexões em processo de conexão",
        disconnectedDesc: "Mostrar conexões desconectadas",
        errorDesc: "Mostrar conexões com erro",
        clear: "Limpar filtros",
        apply: "Aplicar"
      },
      sortModal: {
        title: "Ordenar conexões",
        nameAsc: "Nome (A-Z)",
        nameDesc: "Nome (Z-A)",
        statusOnline: "Status: Online primeiro",
        statusOffline: "Status: Offline primeiro",
        recentFirst: "Mais recentes primeiro",
        oldestFirst: "Mais antigas primeiro",
        close: "Fechar",
        reset: "Limpar ordenação",
        apply: "Aplicar"
      },
      integrations: {
        title: "Integrações para {{instanceName}}",
        connect: "Configurar",
        webhooks: {
          title: "Webhooks",
          description: "Receba eventos em tempo real via Webhook."
        },
        make: {
          title: "Make.com",
          description: "Automatize com Make.com"
        },
        highlevel: {
          title: "HighLevel",
          description: "Integre com HighLevel",
          ghlUserId: "GHL User ID",
          signatureLabel: "Assinatura do remetente",
          signatureSaving: "Salvando...",
          signatureSaved: "Preferência salva!",
          signatureError: "Erro ao salvar preferência."
        },
        n8n: {
          title: "n8n",
          description: "Automatize com n8n"
        }
      },
      leadconnector: {
        title: "Finalizando a conexão com o GHL",
        status: {
          connecting: "Finalizando a conexão com o GHL",
          needLogin: "Faça login para continuar a configuração do HighLevel.",
          awaitAuth: "Aguarde, finalize a autorização no HighLevel e retorne a esta página.",
          loadingPipelines: "Conexão estabelecida. Carregando pipelines...",
          selectPipeline: "Selecione o pipeline padrão para oportunidades."
        },
        labelSelectPipeline: "Selecionar Pipeline:",
        loadingPipelines: "Carregando pipelines...",
        optionSelect: "Selecione um pipeline",
        save: "Salvar Pipeline",
        saving: "Salvando...",
        back: "Voltar",
        successSave: "Pipeline salvo com sucesso!",
        errors: {
          findIntegration: "Erro ao localizar integração HighLevel.",
          loadData: "Erro ao carregar dados do HighLevel.",
          save: "Erro ao salvar pipeline selecionado.",
          unexpectedSave: "Erro inesperado ao salvar pipeline."
        }
      },
      instance: {
        title: "Configuração da Instância",
        configuration: "Configuração da Instância",
        manageSettings: "Gerencie as configurações da sua instância",
        enterName: "Digite o nome da instância",
        noName: "Sem nome",
        editName: "Editar nome",
        edit: "Editar",
        saveName: "Salvar nome",
        cancel: "Cancelar",
        nameError: "O nome não pode ser vazio.",
        status: "Status da Instância",
        statusDescription: "Verifique o status atual e gerencie a conexão",
        currentStatus: "Status Atual",
        connected: "Conectada",
        disconnected: "Desconectada",
        restarting: "Reiniciando...",
        recreate: "Recriar",
        delete: "Excluir",
        close: "Fechar",
        ignoreGroups: "Ignorar Grupos",
        alwaysOnline: "Sempre Online",
        viewMessages: "Visualizar Mensagens",
        rejectCalls: "Rejeitar Chamadas",
        missedCallMsg: "Mensagem de chamada perdida",
        placeholderMsg: "Digite a mensagem para chamadas perdidas...",
        integrations: "Integrações",
        sharing: "Compartilhar",
        saveChanges: "Salvar Alterações",
        shareTitle: "Compartilhar Instância",
        userIdLabel: "ID do usuário",
        userIdPlaceholder: "Digite o ID do usuário",
        assigning: "Atribuindo...",
        assignShare: "Compartilhar",
        sharedUsersTitle: "Usuários com acesso",
        loading: "Carregando...",
        noUsers: "Nenhum usuário com acesso."
      },
      qrcode: {
        instructions: "Escaneie o QR Code para conectar {{instanceName}} ao WhatsApp.",
        alt: "QR Code para {{instanceName}}",
        status: "{{status}}",
        connected: "Status OK!",
        reportProblem: "Reportar problema",
        done: "Concluído",
        error: "QR Code não disponível. Tente recriar a instância e tente novamente.",
        title: "Conectar \"{{instanceName}}\"",
        subtitle: "Escaneie o código QR com seu WhatsApp para conectar sua nova instância",
        generating: "Gerando QR Code...",
        errorGenerating: "Erro ao gerar QR Code",
        recreateInstance: "Recriar Instância",
        recreating: "Recriando..."
      },
      error_qr: {
        title: "Erro ao conectar",
        subtitle: "Não foi possível conectar",
        description: "Ocorreu um erro ao tentar conectar sua instância. Veja detalhes abaixo.",
        details: "Detalhes do erro",
        copyLog: "Copiar log",
        logText: "Erro de conexão: verifique sua internet e tente novamente.",
        solutionsTitle: "Possíveis soluções",
        solution1: "Verifique sua conexão com a internet.",
        solution2: "Recarregue a página e tente novamente.",
        solution3: "Entre em contato com o suporte se o problema persistir.",
        support: "Suporte",
        close: "Fechar",
        retry: "Tentar novamente"
      },
      successqr: {
        title: "Conexão criada!",
        subtitle: "Sucesso!",
        message: "Sua instância foi criada com sucesso.",
        dashboard: "Ir para o painel",
        integrations: "Integrações",
        close: "Fechar",
        qrHint: "Agora, conecte sua instância escaneando o QR Code na tabela de instâncias.",
        recreationTitle: "Instância Recriada!",
        recreationMessage: "Sua instância foi reiniciada com sucesso e está pronta para nova conexão.",
        recreationHint: "A instância foi reiniciada. Escaneie o novo QR Code para reconectar.",
        recreationButton: "Ver Novo QR Code"
      },
      signup: {
        name: "Nome completo",
        email: "Email",
        phone: "Telefone",
        coupon: "Cupom promocional",
        couponOptional: "(opcional)",
        password: "Senha",
        createAccount: "Criar conta",
        alreadyHave: "Já tem uma conta?",
        login: "Fazer login",
        fillAll: "Preencha todos os campos obrigatórios.",
        validEmail: "Digite um e-mail válido.",
        invalidCoupon: "Cupom promocional inválido.",
        errorCreate: "Erro ao criar conta",
        errorSave: "Conta criada, mas houve erro ao salvar dados adicionais.",
        placeholderName: "Seu nome",
        placeholderEmail: "seu@email.com",
        placeholderCoupon: "Digite seu cupom",
        placeholderPassword: "Digite sua senha"
      },
      signin: {
        email: "Email",
        password: "Senha",
        forgotPassword: "Esqueci minha senha",
        login: "Entrar",
        noAccount: "Não tem uma conta?",
        createNow: "Criar agora",
        language: "Idioma",
        selectLanguage: "Selecione o idioma",
        portuguese: "Português",
        english: "Inglês",
        continueWithGoogle: "Continuar com Google",
        connecting: "Conectando...",
        resetNotice: {
          title: "Redefina sua senha",
          message: "Por favor, redefina sua senha para garantir o acesso contínuo à plataforma.",
          resetBtn: "Redefinir senha",
          dismiss: "Fechar"
        }
      },
      fpassword: {
        title: "Recuperar senha",
        instruction: "Digite seu e-mail para receber um link de recuperação",
        email: "Email",
        sendLink: "Enviar link",
        backToLogin: "Voltar para o login",
        invalidEmail: "Por favor, insira um email válido",
        errorSend: "Erro ao enviar email de redefinição de senha.",
        success: "Redirecionando para verificação de e-mail...",
        resend: "Reenviar e-mail"
      },
      verification: {
        title: "Verifique seu e-mail",
        instruction: "Clique no link enviado para ativar sua conta",
        sentTo: "Enviamos um e-mail para",
        notReceived: "Não recebeu o e-mail? Verifique sua pasta de spam",
        resend: "Reenviar e-mail",
        backToLogin: "Voltar ao login"
      },
      resetPassword: {
        title: "Redefinir senha",
        newPassword: "Nova senha",
        confirmNewPassword: "Confirmar nova senha",
        error: "Erro ao redefinir senha.",
        success: "Senha redefinida com sucesso! Você já pode fazer login.",
        save: "Redefinir senha",
        loading: "Salvando...",
        ignore: "Se você não solicitou essa alteração, ignore esta página."
      },
      common: {
        cancel: "Cancelar",
        save: "Salvar",
        saving: "Salvando...",
        close: "Fechar",
        yes: "Sim",
        no: "Não"
      },
      whatsappApiSubtitle: "Preencha abaixo com suas informações para acessar sua conta!",
      webhook: {
        title: "Configurar Webhook",
        status: "Status do Webhook",
        url: "Webhook URL",
        urlPlaceholder: "https://webhook.com/webhook",
        urlInvalid: "URL inválida. Digite uma URL completa começando com http:// ou https://",
        events: "Eventos",
        defaultWebhook: {
          title: "Webhook Padrão Sempre Ativo",
          description: "O webhook padrão para processamento de mensagens está sempre ativo e não pode ser removido. Você pode adicionar webhooks adicionais abaixo."
        },
        sessionStatus: "Status da Sessão",
        sessionStatusDesc: "Mudanças de status da sessão",
        message: "Mensagens",
        messageDesc: "Notificações de novas mensagens recebidas",
        messageAny: "Qualquer Mensagem",
        messageAnyDesc: "Qualquer mensagem recebida ou enviada",
        messageReaction: "Reação",
        messageReactionDesc: "Reações em mensagens",
        messageAck: "Confirmação de Mensagem",
        messageAckDesc: "Confirmação de recebimento/leitura",
        messageWaiting: "Mensagem em Espera",
        messageWaitingDesc: "Mensagens aguardando envio",
        messageEdited: "Mensagem Editada",
        messageEditedDesc: "Mensagens editadas",
        messageRevoked: "Mensagem Removida",
        messageRevokedDesc: "Mensagens apagadas",
        chatArchive: "Chat Arquivado",
        chatArchiveDesc: "Chats arquivados",
        groupJoin: "Entrou no Grupo",
        groupJoinDesc: "Entradas em grupos",
        groupLeave: "Saiu do Grupo",
        groupLeaveDesc: "Saídas de grupos",
        groupParticipants: "Participantes do Grupo",
        groupParticipantsDesc: "Mudanças de participantes",
        groupUpdate: "Grupo Atualizado",
        groupUpdateDesc: "Atualizações de grupo",
        presence: "Presença",
        presenceDesc: "Mudanças de status online/offline",
        pollVote: "Voto em Enquete",
        pollVoteDesc: "Votos em enquetes",
        pollVoteFailed: "Voto em Enquete Falhou",
        pollVoteFailedDesc: "Falha ao votar em enquete",
        labelUpsert: "Label Criada/Atualizada",
        labelUpsertDesc: "Criação/atualização de labels",
        labelDeleted: "Label Removida",
        labelDeletedDesc: "Remoção de labels",
        labelChatAdded: "Label Adicionada ao Chat",
        labelChatAddedDesc: "Label adicionada ao chat",
        labelChatDeleted: "Label Removida do Chat",
        labelChatDeletedDesc: "Label removida do chat",
        callReceived: "Chamada Recebida",
        callReceivedDesc: "Chamadas recebidas",
        callAccepted: "Chamada Aceita",
        callAcceptedDesc: "Chamadas aceitas",
        callRejected: "Chamada Rejeitada",
        callRejectedDesc: "Chamadas rejeitadas",
        engineEvent: "Evento do Motor",
        engineEventDesc: "Eventos internos do motor"
      },
      enterprise: {
        title: "Painel Enterprise",
        loading: "Carregando dados do enterprise...",
        error: "Erro ao carregar dados do enterprise",
        backToHome: "Voltar para Home",
        errors: {
          missingId: "ID do enterprise não encontrado",
          accessDenied: "Acesso negado: usuário não pertence ao enterprise {{id}}",
          invalidRole: "Usuário não possui role válida no enterprise",
          notFound: "Enterprise não encontrado",
          totalLimitExceeded: "Limite total excedido. A enterprise pode ter no máximo {{max}} instâncias alocadas.",
          enterpriseLimitReached: "Enterprise atingiu o limite máximo de {{max}} instâncias.",
          userLimitReached: "Usuário {{userName}} já atingiu o limite de {{limit}} instâncias.",
          adminNoIndividualLimit: "Usuários Admin não possuem limite individual de instâncias"
        },
        stats: {
          users: "Usuários",
          instances: "Instâncias",
          totalUsers: "Total de Usuários",
          totalInstances: "Total de Instâncias",
          instancesUsage: "Instâncias em uso",
          activeInstances: "Ativas",
          onlineNow: "Online agora",
          available: "Disponíveis",
          remainingSlots: "Vagas restantes"
        },
        users: {
          title: "Usuários do Enterprise",
          createUser: "Criar Usuário",
          noUsers: "Nenhum usuário encontrado",
          myAccount: "Minha Conta (Admin)",
          instances: "Instâncias",
          noIndividualLimit: "Sem limite individual - apenas limite da enterprise ({{current}}/{{max}})",
          role: {
            admin: "Administrador",
            normal: "Usuário Normal"
          },
          actions: {
            details: "Ver Detalhes",
            delete: "Remover Usuário",
            createInstance: "Criar Instância"
          },
          form: {
            title: "Criar Novo Usuário",
            subtitle: "Adicione um novo membro ao seu enterprise",
            name: "Nome",
            email: "Email",
            phone: "Telefone",
            password: "Senha (mín: 6 caracteres)",
            role: "Função",
            create: "Criar Usuário",
            creating: "Criando...",
            cancel: "Cancelar",
            success: "Usuário criado com sucesso!",
            error: "Erro ao criar usuário",
            namePlaceholder: "Nome completo do usuário",
            emailPlaceholder: "email@empresa.com",
            phonePlaceholder: "551199999999",
            passwordPlaceholder: "Mín 6 caracteres",
            passwordMinLength: "A senha deve ter pelo menos 6 caracteres.",
            normalDescription: "Pode criar e gerenciar suas próprias instâncias",
            adminDescription: "Acesso total ao painel enterprise e usuários",
            enterpriseInfo: "Informações do Enterprise",
            currentUsers: "Usuários atuais",
            instancesUsed: "Instâncias utilizadas"
          },
          details: {
            title: "Detalhes do Usuário",
            name: "Nome",
            email: "Email",
            role: "Função",
            memberSince: "Membro desde",
            instanceLimit: "Limite de instâncias",
            instances: "Instâncias do Usuário",
            noInstances: "Nenhuma instância encontrada",
            close: "Fechar"
          },
          pagination: {
            showing: "{{start}}-{{end}} de {{total}} usuários"
          },
          limitUpdatedSuccess: "Limite de instâncias atualizado com sucesso!",
          removedSuccess: "Usuário removido com sucesso!",
          confirmRemove: "Tem certeza que deseja remover este usuário?"
        },
        instances: {
          title: "Instâncias do Enterprise",
          myInstances: "Minhas Instâncias",
          refresh: "Atualizar Status",
          refreshing: "Atualizando...",
          noInstances: "Nenhuma instância encontrada",
          name: "Nome",
          instanceName: "Instance Name",
          owner: "Proprietário",
          apiKey: "API Key",
          status: "Status",
                  phone: "Telefone",
        host: "Host",
        actions: "Ações",
          connect: "Conectar via QR Code",
          restart: "Reiniciar",
          recreate: "Recriar",
          delete: "Deletar",
          confirmRestart: "Tem certeza que deseja reiniciar a instância?",
          confirmRecreate: "Tem certeza que deseja recriar a instância?",
          confirmDelete: "Tem certeza que deseja deletar a instância?",
          restarting: "Reiniciando...",
          recreating: "Recriando...",
          deleting: "Deletando...",
          unknown: "Desconhecido",
          notConnected: "Não conectado",
          online: "Online",
          offline: "Offline",
          searchPlaceholder: "Pesquisar instâncias...",
          clearSearch: "Limpar pesquisa",
          searchResults: "{{count}} instância(s) encontrada(s)",
          noSearchResults: "Nenhuma instância encontrada com este filtro",
          integrations: "Integrações",
          openIntegrations: "Abrir Integrações",
          moreOptions: "Mais opções",
          createdForUser: "Instância criada com sucesso para {{userName}}!",
          deletedSuccess: "Instância \"{{instanceName}}\" deletada com sucesso!",
          restartedSuccess: "Instância \"{{instanceName}}\" reiniciada com sucesso!",
          editName: "Editar nome",
          saveName: "Salvar",
          cancelEdit: "Cancelar",
          nameRequired: "Nome é obrigatório",
          nameUpdated: "Nome atualizado com sucesso!",
          errorUpdatingName: "Erro ao atualizar nome"
        },
        createInstance: {
          title: "Nova Instância",
          name: "Nome da Instância",
          namePlaceholder: "Digite o nome da instância",
          owner: "Proprietário da Instância",
          ownerPlaceholder: "Selecione o proprietário",
          create: "Criar Instância",
          creating: "Criando...",
          cancel: "Cancelar",
          success: "Instância criada com sucesso!",
          error: "Erro ao criar instância",
          nameRequired: "Nome da instância é obrigatório",
          ownerRequired: "Selecione um proprietário para a instância",
          limitReached: "{{userName}} atingiu o limite de {{limit}} instâncias.",
          enterpriseLimitReached: "Enterprise atingiu o limite de {{limit}} instâncias.",
          myInstances: "Minha ({{name}})",
          userWithEmail: "{{name}} ({{email}})",
          you: "Você",
          limit: "Limite",
          noIndividualLimit: "Sem limite individual - apenas limite da enterprise",
          instanceLimit: "Limite de instâncias"
        },
        deleteInstance: {
          title: "Confirmar Exclusão",
          message: "Tem certeza que deseja deletar a instância \"{{instanceName}}\"?",
          warning: "Esta ação não pode ser desfeita. A instância será permanentemente removida.",
          confirm: "Deletar Instância",
          cancel: "Cancelar",
          deleting: "Deletando...",
          success: "Instância deletada com sucesso!",
          error: "Erro ao deletar instância",
          instanceName: "Instância",
          permanentRemoval: "Esta ação irá remover a instância permanentemente."
        },
        recreateInstance: {
          title: "Confirmar Recriação",
          message: "Tem certeza que deseja recriar a instância \"{{instanceName}}\"?",
          warning: "A instância atual será deletada e uma nova será criada. Todos os dados serão perdidos.",
          confirm: "Recriar Instância",
          cancel: "Cancelar",
          recreating: "Recriando...",
          success: "Instância recriada com sucesso!",
          error: "Erro ao recriar instância",
          instanceName: "Instância",
          restartWarning: "Esta ação irá reiniciar a instância e gerar um novo QR code."
        },
        pagination: {
          showing: "Mostrando {{start}}-{{end}} de {{total}} instâncias",
          perPage: "por página",
          previous: "Anterior",
          next: "Próximo",
          noInstancesOnPage: "Nenhuma instância na página atual"
        },
        common: {
          decreaseLimit: "Diminuir limite",
          increaseLimit: "Aumentar limite",
          viewDetails: "Ver detalhes",
          removeUser: "Remover usuário",
          backToHome: "Voltar para o Home",
          admin: "Admin",
          normal: "Normal"
        }
      }
    }
  },
  en: {
    translation: {
      profile: {
        loading: "Loading profile...",
        title: "My Profile",
        name: "Name",
        email: "E-mail",
        logout: "Logout"
      },
      home: {
        loading: "Loading...",
        activateTitle: "Activate your subscription",
        activateMsg: "To use Wappfy, activate your subscription. You will have <b>2 free days</b> to try.",
        activateBtn: "Activate now",
        regularizeTitle: "Regularize your subscription",
        regularizeMsg: "Your subscription is inactive. Regularize payment to continue.",
        regularizeBtn: "Regularize",
        signout: "Logout"
      },
      header: {
        documentation: "Documentation",
        documentationSubtitle: "Documentation",
        languageCurrent: "Current language: {{lang}}",
        selectLanguage: "Select language",
        portuguese: "Português",
        english: "English",
        "Português": "Português",
        "English": "English",
        userMenu: "User menu",
        myProfile: "My Profile",
        userId: "User ID",
        copyUserId: "Copy ID",
        copied: "Copied!",
        resetPassword: "Reset password",
        resetPasswordSubtitle: "Change your access password",
        partner: "Wappfy Partner",
        partnerSubtitle: "Earn commission by referring friends",
        support: "Support",
        needHelp: "Need help?",
        manageSubscription: "Manage subscription",
        billing: "Billing",
        opening: "Opening...",
        logout: "Logout",
        endSession: "End session",
        confirmLogout: "Do you want to logout?",
        confirmLogoutMsg: "Are you sure you want to logout?",
        cancel: "Cancel",
        confirm: "Confirm",
        loggingOut: "Logging out...",
        subscription: "Subscription",
        instances: "instances",
        loading: "Loading...",
        enterprise: "Enterprise",
        enterpriseAdmin: "Manage Enterprise",
        enterpriseUser: "Access Enterprise",
        user: "User"
      },
      connectionTable: {
        loading: "Loading connections...",
        error: "Error loading connections",
        tryAgain: "Try again",
        filter: "Filter",
        sort: "Sort",
        sortActive: "Sort active",
        refresh: "Refresh",
        newConnection: "New Connection",
        noInstance: "No instance found",
        createFirst: "Create your first instance to start.",
        noConnections: "No connections found",
        noFilter: "No connection found with this filter.",
        tryAdjust: "Try adjusting the filters.",
        searchPlaceholder: "Search instances...",
        clearSearch: "Clear search",
        name: "Name",
        phone: "Phone",
        apiKey: "API Key",
        instanceName: "Session/InstanceName",
        host: "Host",
        statusTitle: "Status",
        actions: "Actions",
        actionsConfig: {
          connect: "Connect QR Code",
          config: "Configure"
        },
        connect: "Connect QR Code",
        status: {
          online: "Online",
          connecting: "Connecting",
          disconnected: "Disconnected",
          error: "Error",
          unknown: "Unknown",
          waitingConnection: "Waiting connection",
          connected: "Connected"
        },
        pagination: {
          showing: "Showing {{start}}-{{end}} of {{total}} connections",
          perPage: "per page",
          previous: "Previous",
          next: "Next",
          noConnectionsOnPage: "No connections on current page"
        }
      },
      novaConexao: {
        nameTitle: "New connection name",
        namePlaceholder: "Enter a name for the connection",
        creating: "Creating...",
        generate: "Generate QR Code",
        alertName: "Enter a name for the connection."
      },
      filterModal: {
        title: "Filter connections",
        onlineDesc: "Show only online connections",
        connectingDesc: "Show connections in process",
        disconnectedDesc: "Show disconnected connections",
        errorDesc: "Show connections with error",
        clear: "Clear filters",
        apply: "Apply"
      },
      sortModal: {
        title: "Sort connections",
        nameAsc: "Name (A-Z)",
        nameDesc: "Name (Z-A)",
        statusOnline: "Status: Online first",
        statusOffline: "Status: Offline first",
        recentFirst: "Most recent first",
        oldestFirst: "Oldest first",
        close: "Close",
        reset: "Clear sorting",
        apply: "Apply"
      },
      integrations: {
        title: "Integrations for {{instanceName}}",
        connect: "Setup",
        webhooks: {
          title: "Webhooks",
          description: "Receive real-time events via Webhook."
        },
        make: {
          title: "Make.com",
          description: "Automate with Make.com"
        },
        highlevel: {
          title: "HighLevel",
          description: "Integrate with HighLevel",
          ghlUserId: "GHL User ID",
          signatureLabel: "Sender signature",
          signatureSaving: "Saving...",
          signatureSaved: "Preference saved!",
          signatureError: "Error saving preference."
        },
        n8n: {
          title: "n8n",
          description: "Automate with n8n"
        }
      },
      leadconnector: {
        title: "Finalizing connection with GHL",
        status: {
          connecting: "Finalizing connection with GHL",
          needLogin: "Log in to continue HighLevel setup.",
          awaitAuth: "Please finish authorization in HighLevel and return to this page.",
          loadingPipelines: "Connection established. Loading pipelines...",
          selectPipeline: "Select the default pipeline for opportunities."
        },
        labelSelectPipeline: "Select Pipeline:",
        loadingPipelines: "Loading pipelines...",
        optionSelect: "Select a pipeline",
        save: "Save Pipeline",
        saving: "Saving...",
        back: "Back",
        successSave: "Pipeline saved successfully!",
        errors: {
          findIntegration: "Error locating HighLevel integration.",
          loadData: "Error loading HighLevel data.",
          save: "Error saving selected pipeline.",
          unexpectedSave: "Unexpected error saving pipeline."
        }
      },
      instance: {
        title: "Instance Configuration",
        configuration: "Instance Configuration",
        manageSettings: "Manage your instance settings",
        instanceName: "Instance Name",
        enterName: "Enter instance name",
        noName: "No name",
        editName: "Edit name",
        edit: "Edit",
        saveName: "Save name",
        cancel: "Cancel",
        nameError: "Name cannot be empty.",
        status: "Instance Status",
        statusDescription: "Check current status and manage connection",
        currentStatus: "Current Status",
        connected: "Connected",
        disconnected: "Disconnected",
        restarting: "Restarting...",
        recreate: "Recreate",
        delete: "Delete",
        close: "Close",
        ignoreGroups: "Ignore Groups",
        alwaysOnline: "Always Online",
        viewMessages: "View Messages",
        rejectCalls: "Reject Calls",
        missedCallMsg: "Missed call message",
        placeholderMsg: "Enter the message for missed calls...",
        integrations: "Integrations",
        sharing: "Share",
        saveChanges: "Save Changes",
        shareTitle: "Share Instance",
        userIdLabel: "User ID",
        userIdPlaceholder: "Enter the user ID",
        assigning: "Assigning...",
        assignShare: "Share",
        sharedUsersTitle: "Users with access",
        loading: "Loading...",
        noUsers: "No users with access."
      },
      qrcode: {
        instructions: "Scan the QR Code to connect {{instanceName}} to WhatsApp.",
        alt: "QR Code for {{instanceName}}",
        status: "{{status}}",
        connected: "Status OK!",
        reportProblem: "Report problem",
        done: "Done",
        error: "QR Code not available. Try recreating the instance and try again.",
        title: "Connect \"{{instanceName}}\"",
        subtitle: "Scan the QR code with your WhatsApp to connect your new instance",
        generating: "Generating QR Code...",
        errorGenerating: "Error generating QR Code",
        recreateInstance: "Recreate Instance",
        recreating: "Recreating..."
      },
      error_qr: {
        title: "Connection error",
        subtitle: "Could not connect",
        description: "An error occurred while trying to connect your instance. See details below.",
        details: "Error details",
        copyLog: "Copy log",
        logText: "Connection error: check your internet and try again.",
        solutionsTitle: "Possible solutions",
        solution1: "Check your internet connection.",
        solution2: "Reload the page and try again.",
        solution3: "Contact support if the problem persists.",
        support: "Support",
        close: "Close",
        retry: "Try again"
      },
      successqr: {
        title: "Connection created!",
        subtitle: "Success!",
        message: "Your instance was created and connected successfully.",
        dashboard: "Go to dashboard",
        integrations: "Integrations",
        close: "Close",
        qrHint: "Now, connect your instance by scanning the QR Code in the instances table.",
        recreationTitle: "Instance Recreated!",
        recreationMessage: "Your instance was restarted successfully and is ready for new connection.",
        recreationHint: "The instance was restarted. Scan the new QR Code to reconnect.",
        recreationButton: "View New QR Code"
      },
      signup: {
        name: "Full name",
        email: "Email",
        phone: "Phone",
        coupon: "Promo code",
        couponOptional: "(optional)",
        password: "Password",
        createAccount: "Create account",
        alreadyHave: "Already have an account?",
        login: "Sign in",
        fillAll: "Fill in all required fields.",
        validEmail: "Enter a valid email.",
        invalidCoupon: "Invalid promo code.",
        errorCreate: "Error creating account",
        errorSave: "Account created, but failed to save additional data.",
        placeholderName: "Your name",
        placeholderEmail: "your@email.com",
        placeholderCoupon: "Enter your code",
        placeholderPassword: "Enter your password"
      },
      signin: {
        email: "Email",
        password: "Password",
        forgotPassword: "Forgot password",
        login: "Sign in",
        noAccount: "Don't have an account?",
        createNow: "Create now",
        language: "Language",
        selectLanguage: "Select language",
        portuguese: "Portuguese",
        english: "English",
        continueWithGoogle: "Continue with Google",
        connecting: "Connecting...",
        resetNotice: {
          title: "Reset your password",
          message: "Please reset your password to ensure continued access to the platform.",
          resetBtn: "Reset password",
          dismiss: "Close"
        }
      },
      fpassword: {
        title: "Recover password",
        instruction: "Enter your email to receive a recovery link",
        email: "Email",
        sendLink: "Send link",
        backToLogin: "Back to login",
        invalidEmail: "Please enter a valid email",
        errorSend: "Error sending password reset email.",
        success: "Redirecting to email verification...",
        resend: "Resend email"
      },
      verification: {
        title: "Verify your email",
        instruction: "Click the link sent to activate your account",
        sentTo: "We sent an email to",
        notReceived: "Didn't receive the email? Check your spam folder",
        resend: "Resend email",
        backToLogin: "Back to login"
      },
      resetPassword: {
        title: "Reset password",
        newPassword: "New password",
        confirmNewPassword: "Confirm new password",
        error: "Error resetting password.",
        success: "Password reset successfully! You can now log in.",
        save: "Reset password",
        loading: "Saving...",
        ignore: "If you did not request this change, ignore this page."
      },
      common: {
        cancel: "Cancel",
        save: "Save",
        saving: "Saving...",
        close: "Close",
        yes: "Yes",
        no: "No"
      },
      whatsappApiSubtitle: "Fill in below with your information to access your account!",
      webhook: {
        title: "Configure Webhook",
        status: "Webhook Status",
        url: "Webhook URL",
        urlPlaceholder: "https://webhook.com/webhook",
        urlInvalid: "Invalid URL. Enter a full URL starting with http:// or https://",
        events: "Events",
        defaultWebhook: {
          title: "Always Active Default Webhook",
          description: "The default webhook for message processing is always active and cannot be removed. You can add additional webhooks below."
        },
        sessionStatus: "Session Status",
        sessionStatusDesc: "Session status changes",
        message: "Messages",
        messageDesc: "Notifications of new messages received",
        messageAny: "Any Message",
        messageAnyDesc: "Any message received or sent",
        messageReaction: "Reaction",
        messageReactionDesc: "Message reactions",
        messageAck: "Message Ack",
        messageAckDesc: "Message delivery/read confirmation",
        messageWaiting: "Message Waiting",
        messageWaitingDesc: "Messages waiting to be sent",
        messageEdited: "Message Edited",
        messageEditedDesc: "Edited messages",
        messageRevoked: "Message Revoked",
        messageRevokedDesc: "Deleted messages",
        chatArchive: "Chat Archived",
        chatArchiveDesc: "Archived chats",
        groupJoin: "Group Joined",
        groupJoinDesc: "Group join events",
        groupLeave: "Group Left",
        groupLeaveDesc: "Group leave events",
        groupParticipants: "Group Participants",
        groupParticipantsDesc: "Participant changes",
        groupUpdate: "Group Updated",
        groupUpdateDesc: "Group updates",
        presence: "Presence",
        presenceDesc: "Online/offline status changes",
        pollVote: "Poll Vote",
        pollVoteDesc: "Poll votes",
        pollVoteFailed: "Poll Vote Failed",
        pollVoteFailedDesc: "Failed poll votes",
        labelUpsert: "Label Upserted",
        labelUpsertDesc: "Label created/updated",
        labelDeleted: "Label Deleted",
        labelDeletedDesc: "Label removed",
        labelChatAdded: "Label Added to Chat",
        labelChatAddedDesc: "Label added to chat",
        labelChatDeleted: "Label Removed from Chat",
        labelChatDeletedDesc: "Label removed from chat",
        callReceived: "Call Received",
        callReceivedDesc: "Calls received",
        callAccepted: "Call Accepted",
        callAcceptedDesc: "Calls accepted",
        callRejected: "Call Rejected",
        callRejectedDesc: "Calls rejected",
        engineEvent: "Engine Event",
        engineEventDesc: "Internal engine events"
      },
      enterprise: {
        title: "Enterprise Dashboard",
        loading: "Loading enterprise data...",
        error: "Error loading enterprise data",
        backToHome: "Back to Home",
        errors: {
          missingId: "Enterprise ID not found",
          accessDenied: "Access denied: user does not belong to enterprise {{id}}",
          invalidRole: "User does not have a valid role in the enterprise",
          notFound: "Enterprise not found",
          totalLimitExceeded: "Total limit exceeded. The enterprise can have a maximum of {{max}} allocated instances.",
          enterpriseLimitReached: "Enterprise reached the maximum limit of {{max}} instances.",
          userLimitReached: "User {{userName}} has already reached the limit of {{limit}} instances.",
          adminNoIndividualLimit: "Admin users do not have individual instance limits"
        },
        stats: {
          users: "Users",
          instances: "Instances",
          totalUsers: "Total Users",
          totalInstances: "Total Instances",
          instancesUsage: "Instances in use",
          activeInstances: "Active",
          onlineNow: "Online now",
          available: "Available",
          remainingSlots: "Remaining slots"
        },
        users: {
          title: "Enterprise Users",
          createUser: "Create User",
          noUsers: "No users found",
          myAccount: "My Account (Admin)",
          instances: "Instances",
          noIndividualLimit: "No individual limit - only enterprise limit ({{current}}/{{max}})",
          role: {
            admin: "Administrator",
            normal: "Normal User"
          },
          actions: {
            details: "View Details",
            delete: "Remove User",
            createInstance: "Create Instance"
          },
          form: {
            title: "Create New User",
            subtitle: "Add a new member to your enterprise",
            name: "Name",
            email: "Email",
            phone: "Phone",
            password: "Password (min: 6 characters)",
            role: "Role",
            create: "Create User",
            creating: "Creating...",
            cancel: "Cancel",
            success: "User created successfully!",
            error: "Error creating user",
            namePlaceholder: "Full name of the user",
            emailPlaceholder: "email@company.com",
            phonePlaceholder: "551199999999",
            passwordPlaceholder: "Min: 6 characters",
            passwordMinLength: "Password must have at least 6 characters.",
            normalDescription: "Can create and manage their own instances",
            adminDescription: "Full access to enterprise panel and users",
            enterpriseInfo: "Enterprise Information",
            currentUsers: "Current users",
            instancesUsed: "Instances used"
          },
          details: {
            title: "User Details",
            name: "Name",
            email: "Email",
            role: "Role",
            memberSince: "Member since",
            instanceLimit: "Instance limit",
            instances: "User Instances",
            noInstances: "No instances found",
            close: "Close"
          },
          pagination: {
            showing: "{{start}}-{{end}} of {{total}} users"
          },
          limitUpdatedSuccess: "Instance limit updated successfully!",
          removedSuccess: "User removed successfully!"
        },
        instances: {
          title: "Enterprise Instances",
          myInstances: "My Instances",
          refresh: "Refresh Status",
          refreshing: "Refreshing...",
          noInstances: "No instances found",
          name: "Name",
          instanceName: "Instance Name",
          owner: "Owner",
          apiKey: "API Key",
          status: "Status",
                  phone: "Phone",
        host: "Host",
        actions: "Actions",
          connect: "Connect via QR Code",
          restart: "Restart",
          recreate: "Recreate",
          delete: "Delete",
          confirmRestart: "Are you sure you want to restart the instance?",
          confirmRecreate: "Are you sure you want to recreate the instance?",
          confirmDelete: "Are you sure you want to delete the instance?",
          restarting: "Restarting...",
          recreating: "Recreating...",
          deleting: "Deleting...",
          unknown: "Unknown",
          notConnected: "Not connected",
          online: "Online",
          offline: "Offline",
          searchPlaceholder: "Search instances...",
          clearSearch: "Clear search",
          searchResults: "{{count}} instance(s) found",
          noSearchResults: "No instances found with this filter",
          integrations: "Integrations",
          openIntegrations: "Open Integrations",
          moreOptions: "More options",
          createdForUser: "Instance created successfully for {{userName}}!",
          deletedSuccess: "Instance \"{{instanceName}}\" deleted successfully!",
          restartedSuccess: "Instance \"{{instanceName}}\" restarted successfully!",
          editName: "Edit name",
          saveName: "Save",
          cancelEdit: "Cancel",
          nameRequired: "Name is required",
          nameUpdated: "Name updated successfully!",
          errorUpdatingName: "Error updating name"
        },
        createInstance: {
          title: "New Instance",
          name: "Instance Name",
          namePlaceholder: "Enter instance name",
          owner: "Instance Owner",
          ownerPlaceholder: "Select owner",
          create: "Create Instance",
          creating: "Creating...",
          cancel: "Cancel",
          success: "Instance created successfully!",
          error: "Error creating instance",
          nameRequired: "Instance name is required",
          ownerRequired: "Select an owner for the instance",
          limitReached: "{{userName}} reached the limit of {{limit}} instances.",
          enterpriseLimitReached: "Enterprise reached the limit of {{limit}} instances.",
          myInstances: "Mine ({{name}})",
          userWithEmail: "{{name}} ({{email}})",
          you: "You",
          limit: "Limit",
          noIndividualLimit: "No individual limit - only enterprise limit",
          instanceLimit: "Instance limit"
        },
        deleteInstance: {
          title: "Confirm Deletion",
          message: "Are you sure you want to delete the instance \"{{instanceName}}\"?",
          warning: "This action cannot be undone. The instance will be permanently removed.",
          confirm: "Delete Instance",
          cancel: "Cancel",
          deleting: "Deleting...",
          success: "Instance deleted successfully!",
          error: "Error deleting instance",
          instanceName: "Instance",
          permanentRemoval: "This action will permanently remove the instance."
        },
        recreateInstance: {
          title: "Confirm Recreation",
          message: "Are you sure you want to recreate the instance \"{{instanceName}}\"?",
          warning: "The current instance will be deleted and a new one will be created. All data will be lost.",
          confirm: "Recreate Instance",
          cancel: "Cancel",
          recreating: "Recreating...",
          success: "Instance recreated successfully!",
          error: "Error recreating instance",
          instanceName: "Instance",
          restartWarning: "This action will restart the instance and generate a new QR code."
        },
        pagination: {
          showing: "Showing {{start}}-{{end}} of {{total}} instances",
          perPage: "per page",
          previous: "Previous",
          next: "Next",
          noInstancesOnPage: "No instances on current page"
        },
        common: {
          decreaseLimit: "Decrease limit",
          increaseLimit: "Increase limit",
          viewDetails: "View details",
          removeUser: "Remove user",
          backToHome: "Back to Home",
          admin: "Admin",
          normal: "Normal"
        }
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'pt',
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;